<template>
  <section
    class="max-w-4xl px-6 py-12 mx-auto text-neutral-800 dark:text-neutral-200"
  >
    <h1 class="mb-8 text-3xl font-bold">
      {{ $t("terms.title") }}
    </h1>

    <div class="space-y-8">
      <div v-for="(section, index) in sections" :key="index">
        <h2 class="mb-2 text-xl font-semibold">
          {{ section?.title ? $t(section.title) : "Section" }}
        </h2>
        <ul v-if="section?.items" class="ml-6 space-y-1 list-disc">
          <li v-for="(item, i) in section.items" :key="i">
            {{ item ? $t(item) : "Item" }}
          </li>
        </ul>
        <p v-else>{{ section?.content ? $t(section.content) : "Content" }}</p>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const i18n = useI18n();
useSeoMeta({
  title: i18n.t("legalKeys.termsAndConditions"),
});

const sections = [
  {
    title: "terms.sections.studio.title",
    content: "terms.sections.studio.content",
  },
  {
    title: "terms.sections.services.title",
    content: "terms.sections.services.content",
  },
  {
    title: "terms.sections.bookings.title",
    content: "terms.sections.bookings.content",
  },
  {
    title: "terms.sections.cancellations.title",
    items: [
      "terms.sections.cancellations.points.p1",
      "terms.sections.cancellations.points.p2",
      "terms.sections.cancellations.points.p3",
    ],
  },
  {
    title: "terms.sections.payments.title",
    content: "terms.sections.payments.content",
  },
  {
    title: "terms.sections.studioUse.title",
    content: "terms.sections.studioUse.content",
  },
  {
    title: "terms.sections.intellectual.title",
    content: "terms.sections.intellectual.content",
  },
  {
    title: "terms.sections.privacy.title",
    content: "terms.sections.privacy.content",
  },
  {
    title: "terms.sections.liability.title",
    content: "terms.sections.liability.content",
  },
  {
    title: "terms.sections.changes.title",
    content: "terms.sections.changes.content",
  },
];
</script>
